module.exports = __webpack_public_path__ + "static/media/technology-forest.902bd84f.png";